import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBecepsLeftArm: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBecepsLeftArm"><Path d="M11.7512 12.9258C8.83333 7.77778 2.49753 9.79401 2.5 14.8024C2.5 23.1247 16.3614 22.6 21.1847 19.0969C22.7559 10.1664 18.2035 2.5 13.1103 2.5C7.99117 2.5 11.181 9.59753 15.0394 6.28535" stroke="currentColor" strokeLinejoin="round"/><Path d="M14.0013 7C16.6101 10.7993 15.1841 12.1123 16.5013 15C14.484 13.2708 11.4827 12.2719 9.11328 14.05" stroke="currentColor"/></CentralIconBase>;
});

export default IconBecepsLeftArm;
